import React from 'react';
import {
  withStyles,
  Theme,
  createStyles,
  WithStyles,
} from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Container from '@material-ui/core/Container';
import Typography from '../components/Typography';

import ChartPic from '../../svg/undraw_Charts_re_5qe9.svg'
import SetupPic from '../../svg/undraw_Setup_re_y9w8.svg'
import ExportPic from '../../svg/undraw_export_files_re_99ar.svg'
import FlowPic from '../../svg/undraw_User_flow_re_bvfx.svg'
import CodePic from '../../svg/undraw_code_typing_7jnv.svg'

const styles = (theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      overflow: 'hidden',
      backgroundColor: 'white',
    },
    container: {
      marginTop: theme.spacing(15),
      marginBottom: theme.spacing(30),
      display: 'flex',
      position: 'relative',
    },
    item: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      padding: theme.spacing(0, 5),
    },
    image: {
      height: 100,
    },
    title: {
      marginTop: theme.spacing(5),
      marginBottom: theme.spacing(5),
    },
    curvyLines: {
      pointerEvents: 'none',
      position: 'absolute',
      top: -180,
    },
  });

function ProductValues(props: WithStyles<typeof styles>) {
  const { classes } = props;

  return (
    <section className={classes.root}>
      <Container className={classes.container}>
        <img
          src="/static/themes/onepirate/productCurvyLines.png"
          className={classes.curvyLines}
          alt="curvy lines"
        />
        <Grid container spacing={5}>
          <Grid item xs={12} md={4}>
            <div className={classes.item}>
              <img
                className={classes.image}
                src={SetupPic}
              />
              <Typography variant="h6" className={classes.title}>
                AWS MTURK READY
              </Typography>
              <Typography variant="h5">
                {
                  'Ready to use with MTurk External Question'
                }
              </Typography>
            </div>
          </Grid>
          <Grid item xs={12} md={4}>
            <div className={classes.item}>
            <img
                className={classes.image}
                src={CodePic}
              />
              <Typography variant="h6" className={classes.title}>
                JSON BASED ANNOTATION
              </Typography>
              <Typography variant="h5">
                {
                  'Build complex annotation UI with JSON'
                }
              </Typography>
            </div>
          </Grid>

          <Grid item xs={12} md={4}>
            <div className={classes.item}>
              <img
                className={classes.image}
                src={FlowPic}
              />
              <Typography variant="h6" className={classes.title}>
                Annotation Workflow
              </Typography>
              <Typography variant="h5">
                {'Design Instruction, Tutorial, Qualification Exam and Annotation Tasks'}
              </Typography>
            </div>
          </Grid>

          <Grid item xs={12} md={4}>
            <div className={classes.item}>
              <img
                className={classes.image}
                src={ChartPic}
              />
              <Typography variant="h6" className={classes.title}>
                Useful Statistics
              </Typography>
              <Typography variant="h5">
                {'Monitor annotation process with useful metrics'}
              </Typography>
            </div>
          </Grid>

          <Grid item xs={12} md={4}>
            <div className={classes.item}>
              <img
                  className={classes.image}
                  src={ExportPic}
                />
              <Typography variant="h6" className={classes.title}>
                REPRODUCIBILITY
              </Typography>
              <Typography variant="h5">
                {'Reproducable data collection framework'}
              </Typography>
            </div>
          </Grid>

        </Grid>
      </Container>
    </section>
  );
}

export default withStyles(styles)(ProductValues);
